import { render, staticRenderFns } from "./ParamsFerme.vue?vue&type=template&id=55e58c4a"
import script from "./ParamsFerme.vue?vue&type=script&lang=js"
export * from "./ParamsFerme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports